export default [[value => value, 'This field is required.']]
